import React from 'react';
import ResetPasswordPage from '../pages/auth/reset-password/ResetPasswordPage'

function ResetPassword() {

	return (
		<ResetPasswordPage />
	);
}

export default ResetPassword;
